import React, { useState } from 'react';
import {
  Tooltip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconWrapper } from '../../elements/IconWrapper/Index';
import { pxToRem, pxTovW } from 'libs/shared-ui/src/commonUtils/resizeUtils';
import { IStyles } from 'libs/shared-ui/src/commonUtils/styleUtils';

const styles: IStyles = {
  text: {
    color: '#FFFFFF',
  },
};
export const MarkingSchemeTooltip = () => {
  const [open, setOpen] = useState(false);
  const handleToggle = () => setOpen((prev) => !prev);
  const handleClose = () => setOpen(false);
  return (
    <Tooltip
      arrow
      placement="top"
      open={open}
      onClose={handleClose} // required for hover out
      onOpen={() => setOpen(true)}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: '#000',
            margin: 0,
            padding: { xs: pxToRem(12), md: pxTovW(12) },
            borderRadius: pxToRem(8),
          },
        },
        arrow: {
          sx: {
            color: '#000',
          },
        },
      }}
      title={
        <Box
          sx={{
            background: '#000000',
            color: '#FFFFFF',
            border: '1px solid #FFFFFF',
            borderRadius: pxToRem(4),
            '& *': {
              color: '#FFFFFF',
            },
            '& .MuiTableCell-root': {
              border: '1px solid #FFFFFF',
            },
            // Prevent double borders
            '& .MuiTable-root': {
              borderCollapse: 'collapse',
            },
          }}
        >
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center" colSpan={2} sx={{ fontWeight: 900 }}>
                  <Typography variant="h5" sx={styles.text}>
                    Marking Scheme
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Typography variant="smallText" sx={styles.text}>
                    Correct Answer
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="smallText" sx={styles.text}>
                    Four Marks (+4)
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Typography variant="smallText" sx={styles.text}>
                    Incorrect Answer
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="smallText" sx={styles.text}>
                    Minus One Mark (-1)
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Typography variant="smallText" sx={styles.text}>
                    Unanswered
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="smallText" sx={styles.text}>
                    No Mark (0)
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      }
    >
      <IconButton onClick={handleToggle}>
        <IconWrapper
          name="tooltip-black"
          parentFolder="icons"
          type="png"
          size="small"
          customSx={{
            height: { xs: pxToRem(14), md: pxTovW(20), lg: pxTovW(18) },
            width: { xs: pxToRem(14), md: pxTovW(20), lg: pxTovW(18) },
            cursor: 'pointer',
          }}
        />
      </IconButton>
    </Tooltip>
  );
};
